export enum SubscriptionStatusTypes {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  PAST_DUE = 'PAST_DUE',
  TRIALING = 'TRIALING',
  PAUSED = 'PAUSED',
}
